<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-users</v-icon>Copy Course Content
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <!--<v-toolbar dark color="secondary">
      <v-chip color text-color="white" @click="e1 = 1">
        <v-avatar>
          <v-icon x-small>fa-user</v-icon>
        </v-avatar>
        {{ selectedCustomerCount }} Selected Customers
      </v-chip>
    </v-toolbar>-->
    <div class="scroll-y">
      <v-stepper v-model="e1" class="no-transition">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1"
            >Select Partners</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <h4 v-if="allCustomersEnrolled">
              Course copied to the all partners.
            </h4>
            <!--<v-text-field
              v-model="customerSearch"
              v-if="!allCustomersEnrolled"
              label="Filter Customers By Name"
              type="text"
              @change="applyCustomerSearch"
            ></v-text-field>-->
            <v-data-table
              v-model="selectedUsers"
              v-if="!allCustomersEnrolled"
              :headers="customerHeaders"
              :options.sync="customerOptions"
              :server-items-length="serverCustomerItemsLength"
              :loading="customerLoading"
              :items="customers"
              item-key="user_id"
              show-select
            ></v-data-table>
          </v-stepper-content>
          <!--<v-stepper-content step="3" class="max-height-list scroll-y">
            <date-picker></date-picker>
          </v-stepper-content>-->
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <div v-if="e1 == 1">
          <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
          <v-btn color="primary" @click="copyCourse">Copy Course</v-btn>
        </div>
        <!--<div v-if="e1 == 2">
          <v-btn color="primary" class="mr-1" @click="e1 = 1">Back</v-btn>
          <v-btn color="primary" @click="e1 = 3">Next</v-btn>
        </div>
        <div v-if="e1 == 3">
          <v-btn color="primary" class="mr-1" @click="e1 = 2">Back</v-btn>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="enrolUsers">Enrol Selected Users</v-btn>
        </div>-->
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import partnerAPI from '@/api/partner.js';
export default {
  name: 'UserDetails',
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customerHeaders: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'Email', value: 'email' },
      ],
      loading: false,
      e1: 1,
      selectedUsers: [],
      customerSearch: '',
      customers: [],
      customerSearchParams: '',
      customerOptions: {},
      customerLoading: false,
      customerPagination: {},
      successMessage: 'Course copied successfully.',
      errorMessage: 'Oops, something went wrong!',
      nothingSelected: "You haven't selected any Customers.",
      allCustomersEnrolled: false,
      confirmCopy:
        "Are you sure you want to copy your course? Please make sure you have finished editing your course before copying to your customers as it can't be edited once you press yes.",
    };
  },
  computed: {
    serverCustomerItemsLength: function () {
      return this.customerPagination.total;
    },
    customerItemsPerPage: function () {
      return this.customerPagination.per_page;
    },
    customerPage: function () {
      return this.customerPagination.current_page;
    },
    customerParams: function () {
      return this.$gf.getQueryString(
        this.customerOptions,
        this.serverCustomerItemsLength
      );
    },
    selectedCustomersTotal: function () {
      return this.selectedUsers.length;
    },
  },
  watch: {
    customerOptions: {
      handler() {
        this.getCustomers();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getCustomers() {
      //alert(this.user_id);
      this.customerLoading = true;
      partnerAPI
        .getPartners(
          this.customerParams,
          this.customerSearchParams
          //this.id
        )
        .then((resp) => {
          this.customers = resp.data.data;
          this.customerPagination = resp.data.meta.pagination;
          this.customerLoading = false;
          this.customers.length == 0
            ? (this.allCustomersEnrolled = true)
            : (this.allCustomersEnrolled = false);
        });
      /*this.loading = true;
      partnerAPI.getPartners(this.params + '&level=all', this.searchParams).then(resp => {
        this.customers = resp.data.data;
        this.customerPagination = resp.data.meta.pagination;
        this.loading = false;
        this.customers.length == 0
            ? (this.allCustomersEnrolled = true)
            : (this.allCustomersEnrolled = false);
      });*/
    },
    applyCustomerSearch() {
      this.customerSearchParams =
        this.customerParams +
        '&search=company_name:' +
        this.customerSearch +
        ';last_name:' +
        this.customerSearch;
      this.getCustomers();
    },
    processSelectedUsers() {
      let users = [];
      this.selectedUsers.forEach(function (x) {
        users.push(x.user_id);
      });
      return users;
    },
    process() {
      //alert(this.processSelectedUsers());
      this.loading = true;
      courseAPI
        .assignCourseToPartners(this.id, {
          users: this.processSelectedUsers(),
        })
        .then(() => {
          EventBus.$emit('COURSES_UPDATED', this.params);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
      this.selectedDate = '';
      this.process();
    },
    setADate(toast) {
      this.$snotify.remove(toast.id);
      this.loading = false;
      this.el = 3;
    },
    copyCourse() {
      this.$snotify.confirm(this.confirmCopy, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Yes',
            className: 'toast-continue-button',
            action: (toast) => this.processCopyCourse(toast),
          },
        ],
      });
    },
    processCopyCourse(toast) {
      this.$snotify.remove(toast.id);
      if (this.selectedCustomerCount === 0) {
        this.$snotify.error(this.nothingSelected);
      } else {
        this.process();
      }
    },
    setEventBus() {
      EventBus.$on('DATE_SELECTED', (date) => {
        this.deadlineSet = true;
        this.selectedDate = date;
      });
    },
    closePanel() {
      this.$emit('closePanel', {});
    },
  },
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}
</style>
